import { Injectable, Inject } from '@angular/core';
import { User } from '../model/user.model';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') private baseUrl: string) {}

  getUserById(id: number): Observable<User> {
    return this.httpClient.get<User>(`${this.baseUrl}/api/User/GetUserById/${id}`);
  }

  addUser(user: User){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const body = JSON.stringify(user);
    return this.httpClient.post(this.baseUrl + '/api/User/AddUser', body, httpOptions);
  }

  editUser(user: User): Observable<User> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const body = JSON.stringify(user);
    return this.httpClient.post<User>(`${this.baseUrl}/api/User/EditUser/${user.id}`, body, httpOptions);
  }

  register(user: User): Observable<User> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.httpClient.post<User>(`${this.baseUrl}/api/User/RegisterUser`, user, httpOptions);
  }

  GetAll(): Observable <User[]>{
    return this.httpClient.get<User[]>(this.baseUrl+'/api/User/GetAll')
  }


}
